import createReducer from '../createReducer';

const initialState = {
    events:[],
    searchEvents:[],
    eventsByRole:[],
    isEventsFound:false,
    accounts:[],
    hasMultipleAccounts:false,
    permissions:[],
    eventsReport:[],
    getEventsByRoleXHR:null,
    getEventsXHR:null,
    getAccountsXHR:null,
    getAccountsCountXHR:null,
    deleteEventXHR:null,
    getEventsReportXHR:null
};

const reducer = createReducer('suggestions',initialState);

export default reducer;